import React from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import Navbar from "../components/Navbar/Navbar";
import AuthPage from "../pages/Auth";
import Login from "../pages/Auth/Login/login";
import HomePage from "../pages/Home/Home";
import ShowTenyZarainaPage from "../pages/TenyZaraina/ShowTenyZaraina/ShowTenyZaraina";
import UpdateTenyzaraina from "../pages/TenyZaraina/EditTenyZaraina/UpdateTenyZaraina";
import TenyZarainaPage from "../pages/TenyZaraina";
import AddTenyZaraina from "../pages/TenyZaraina/CreateTenyZaraina/AddTenyzaraina";
import ThemePage from "../pages/Theme";
import ShowTheme from "../pages/Theme/ShowTheme/ThemePage";
import AddTheme from "../pages/Theme/CreateTheme/AddTheme";
import UpdateTheme from "../pages/Theme/EditTheme/UpdateTheme";
import UserPage from "../pages/User";
import ShowUser from "../pages/User/ShowUser/ShowUser";
import MessagePage from "./../pages/Message/Message";
import VavakaPage from "./../pages/Vavaka/index";
import ShowVavaka from "./../pages/Vavaka/ShowVavaka/ShowVavaka";
import CreateVavaka from "./../pages/Vavaka/CreateVavaka/CreateVavaka";
import EditVavaka from "./../pages/Vavaka/EditVavaka/EditVavaka";
import CreateUser from "../pages/User/CreateUser/CreateUser";
import HiraPage from "./../pages/Hira/index";
import ShowHira from "./../pages/Hira/ShowHira/ShowHira";
import CreateHira from "./../pages/Hira/CreateHira/CreateHira";
import EditHira from "./../pages/Hira/EditHira/EditHira";
import DonPage from "../pages/Don";
import ShowDon from "../pages/Don/ShowDon/ShowDon";

const Routing = () => {
  const location = useLocation();

  return (
    <div>
      {!location.pathname.includes("auth") && <Navbar />}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/room/:id" element={<MessagePage />} />

        {/* Don */}
        <Route path="/don" element={<DonPage />}>
          <Route path="" element={<ShowDon />} />
        </Route>

        {/* Teny Zaraina */}
        <Route path="/tenyzaraina" element={<TenyZarainaPage />}>
          <Route path="" element={<ShowTenyZarainaPage />} />
          <Route path="addTenyzaraina" element={<AddTenyZaraina />} />
          <Route path="updateTenyzaraina/:id" element={<UpdateTenyzaraina />} />
        </Route>

        {/* Theme */}
        <Route path="/theme" element={<ThemePage />}>
          <Route path="" element={<ShowTheme />} />
          <Route path="addTheme" element={<AddTheme />} />
          <Route path="updateTheme/:id" element={<UpdateTheme />} />
        </Route>

        {/* Vavaka */}
        <Route path="/vavaka" element={<VavakaPage />}>
          <Route path="" element={<ShowVavaka />} />
          <Route path="addVavaka" element={<CreateVavaka />} />
          <Route path="updateVavaka/:id" element={<EditVavaka />} />
        </Route>

        {/* Hira */}
        <Route path="/hira" element={<HiraPage />}>
          <Route path="" element={<ShowHira />} />
          <Route path="addHira" element={<CreateHira />} />
          <Route path="updateHira/:id" element={<EditHira />} />
        </Route>

        <Route path="/tenyzaraina" element={<TenyZarainaPage />}>
          <Route path="" element={<ShowTenyZarainaPage />} />
          <Route path="addTenyzaraina" element={<AddTenyZaraina />} />
          <Route path="updateTenyzaraina/:id" element={<UpdateTenyzaraina />} />
        </Route>

        {/* User */}
        <Route path="/user" element={<UserPage />}>
          <Route path="" element={<ShowUser />} />
          <Route path="addUser" element={<CreateUser />} />
        </Route>

        {/* Authentification */}
        <Route path="/auth" element={<AuthPage />}>
          <Route path="login" element={<Login />} />
        </Route>
      </Routes>

    </div>
  );
};

export default Routing;
